import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { yellow } from "@/pages/(app)/home/components/colors";
import {
  AlertCircle,
  CalendarFold,
  LucideMessageCircleWarning,
} from "lucide-react";
import { useCallback, useEffect } from "react";
import { useReturnRequestsFilters } from "../../../providers/use-return-requests-filters";
import useCountFilteredReturnRequests from "@babackapp/private-api-client/client/use-count-filtered-return-requests";
import useTranslation from "@babackapp/translations/use-translation";
import QuickFilterItem from "./quick-filter-item";

export default function ShippingTooLongQuickFilter() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();
  const { filters, clearAll, quickFilter, setQuickFilter } =
    useReturnRequestsFilters();

  const status = filters.get("status");

  const isCarrierIssues = quickFilter === "shippingTooLong";
  const active = !status && isCarrierIssues;

  const onClick = useCallback(() => {
    clearAll();

    setQuickFilter("shippingTooLong");
  }, [filters, active, isCarrierIssues]);

  const { data: results, refetch } = useCountFilteredReturnRequests({
    shopId: shop.id,
    filters,
    quickFilter: "shippingTooLong",
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  if (!results?.totalCount) return <></>;

  return (
    <QuickFilterItem
      count={results?.totalCount}
      active={active}
      title={t("returnRequestsQuickFilters.shippingTooLong.title")}
      description={t("returnRequestsQuickFilters.shippingTooLong.description")}
      icon={<AlertCircle className="size-3" color={yellow} />}
      onClick={onClick}
    />
  );
}
